<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">Edit Goal</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  @if (loaded) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" id="form">
      @if (getAvailableGoalTypes().length) {
        <div class="d-flex mb-5 justify-content-end">
          <select class="form-select me-2 w-50" [(ngModel)]="goalType" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="null" disabled>Choose a goal type</option>
            @for (goalType of getAvailableGoalTypes(); track goalType) {
              <option [ngValue]="goalType">{{ goalType.name }}</option>
            }
          </select>
          <button type="button" class="btn btn-primary" (click)="addGoalType()" [disabled]="!goalType"><i class="bi bi-plus-lg"></i></button>
        </div>
      }
      <table class="table">
        <thead>
          <tr>
            <th></th>
            <th>Min Age</th>
            <th>Payout Amount</th>
            <th>Payout Percent</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Default</td>
            <td>
              <input type="text" class="form-control" formControlName="minAge">
            </td>
            <td>
              <input type="text" class="form-control" formControlName="payoutAmount">
            </td>
            <td>
              <input type="text" class="form-control" formControlName="payoutPercent">
            </td>
          </tr>
          @for (type of getFormGoalTypeControls(); track type) {
            <tr formArrayName="types">
              <ng-container [formGroup]="type">
                <td>
                  {{ type.get('name')?.value }}
                </td>
                <td>
                  <input type="text" class="form-control" formControlName="minAge">
                </td>
                <td>
                  <input type="text" class="form-control" formControlName="payoutAmount">
                </td>
                <td>
                  <input type="text" class="form-control" formControlName="payoutPercent">
                </td>
                <td class="text-end">
                  <button class="btn btn-sm btn-danger" type="button" appConfirm (click)="deleteOfferType(type)"><i
                  class="bi bi-trash"></i></button>
                </td>
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
      <div class="row mt-3">
        <div class="col-3">
          <label for="private" class="form-label">Private</label>
          <app-input-switch id="private" formControlName="private"></app-input-switch>
        </div>
        <div class="col-3">
          <label for="multiple" class="form-label">Multiple</label>
          <app-input-switch id="multiple" formControlName="multiple"></app-input-switch>
        </div>
      </div>
    </form>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>
  <button form="form" type="submit" class="btn btn-primary fw-bold">Update</button>
</div>
